<script lang="ts" module>
	export interface TableBodyProps {
		dataCy: string;
		children?: import('svelte').Snippet;
		class?: string;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { dataCy, children, ...rest }: TableBodyProps = $props();
</script>

<tbody class={twMerge('bg-white', rest.class)} data-cy={`${dataCy}-body`}>
	{@render children?.()}
</tbody>
